import React from "react";
import Header from "./Helper/Header";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Helper/Footer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCartProducts } from "./features/cartSlice";
import { fetchWishlist } from "./features/wishlistSlice";
import { fetchUserLocation } from "./features/locationSlice";
import { fetchUserDetails } from "./features/userDetailSlice";
// import NotAvailable from './NotAvailable';
const Layout = () => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Fetch location data on first load
    dispatch(fetchUserLocation());
    window.scrollTo(0, 0);
    // Load cart and wishlist data if user is logged in
    if (user && token) {
      dispatch(fetchCartProducts());
      dispatch(fetchWishlist());
      dispatch(fetchUserDetails());
    }
  }, []);

  // Check if current path is home or product page
  const shouldShowLoading = () => {
    return location.pathname === "/";
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    // Only show loading for home and product pages
    if (shouldShowLoading()) {
      setIsLoading(true);
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1800);
      return () => clearTimeout(timer);
    } else {
      setIsLoading(false);
    }
  }, [location.pathname]);

  // Add keyframes for multiple animations
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
      @keyframes bounce {
        0%, 100% { transform: translateY(0) scale(1); }
        50% { transform: translateY(-20px) scale(1.1); }
      }

      @keyframes rotate {
        0% { transform: rotate(0deg); }
        25% { transform: rotate(10deg); }
        75% { transform: rotate(-10deg); }
        100% { transform: rotate(0deg); }
      }

      @keyframes colorChange {
        0% { color: #FF69B4; }
        33% { color: #6B4E9B; }
        66% { color: #FF1493; }
        100% { color: #FF69B4; }
      }
    `;
  document.head.appendChild(styleSheet);

  const loadingOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "white",
    display: isLoading ? "flex" : "none",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  };

  const loadingTextContainerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
  };

  const getCharStyle = (index) => ({
    display: "inline-block",
    fontFamily: "cursive",
    fontSize: "3rem",
    fontWeight: "bold",
    animation: `
        bounce 0.4s ease-in-out infinite,
        rotate 0.7s ease-in-out infinite,
        colorChange 1s infinite
      `,
    animationDelay: `${index * 0.1}s`,
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
    letterSpacing: "0.05em",
  });

  const subTextStyle = {
    fontSize: "1.2rem",
    color: "#6B4E9B",
    marginTop: "20px",
    animation: "colorChange 1s infinite",
    fontFamily: "Arial, sans-serif",
  };

  const candyIconStyle = {
    fontSize: "2rem",
    marginBottom: "10px",
    animation: "rotate 0.8s ease-in-out infinite",
  };

  const text = "Sweetz n' Snackz";

  // Function to check if user is from India
  // const isIndianUser = () => {
  //   if (!locationData) return true; // If no location data, allow access
  //   return (
  //     locationData.countryCode === "IN" || locationData.country === "India"
  //   );
  // };

  return (
    <>
      {shouldShowLoading() && isLoading && (
        <div style={loadingOverlayStyle}>
          <div style={loadingTextContainerStyle}>
            <div>
              {"Sweetz".split("").map((char, index) => (
                <span key={`sweetz-${index}`} style={getCharStyle(index)}>
                  {char}
                </span>
              ))}
              <span style={getCharStyle(2)}>&nbsp;</span>
              {"n'".split("").map((char, index) => (
                <span key={`n-${index}`} style={getCharStyle(index + 4)}>
                  {char}
                </span>
              ))}
              <span style={getCharStyle(10)}>&nbsp;</span>
              {"Snackz".split("").map((char, index) => (
                <span key={`snackz-${index}`} style={getCharStyle(index + 8)}>
                  {char}
                </span>
              ))}
            </div>
            <span style={subTextStyle}>Loading sweet treats...</span>
            <span style={candyIconStyle}>🍪</span>
          </div>
        </div>
      )}
      <Header />
      <Outlet />
      <Footer />
    </>
  );

  // Show NotAvailable component for non-Indian users
  // return <NotAvailable />;
};

export default Layout;
